import { RouteObject } from "react-router-dom";
import pathRoutes from "../../../routes/pathRoutes";
import Authenticated from "../../../utils/Authenticated";
import MasterTablesList from "../masterTables";
import MasterTablesListLayout from "../layouts/layout";
import LayoutEditMasterTable from "../layouts/layoutEdit";
import EditMasterTables from "../editMasterTables";
import { PrivateRoutes } from "@app/utils/PrivateRoutes";
import { RolesTypes } from "@app/pages/users/utils/helpers";

const routesMasterTables: RouteObject = {
  path: pathRoutes.ADMIN_MASTER_TABLES,
  element: (
    <Authenticated>
      <MasterTablesListLayout />
    </Authenticated>
  ),
  children: [
    {
      path: "",
      index: true,
      element: (
        <Authenticated>
          <MasterTablesList />
        </Authenticated>
      ),
    },
    {
      path: "nuevo",
      element: (
        <PrivateRoutes permissions={[RolesTypes.ADMIN, RolesTypes.SUPER_ADMIN]}>
          <LayoutEditMasterTable />
        </PrivateRoutes>
      ),
      children: [
        {
          path: ":nameTable",
          element: (
            <Authenticated>
              <EditMasterTables />
            </Authenticated>
          ),
        },
      ],
    },
    {
      path: "editar",
      element: (
        <PrivateRoutes permissions={[RolesTypes.ADMIN, RolesTypes.SUPER_ADMIN]}>
          <LayoutEditMasterTable />
        </PrivateRoutes>
      ),
      children: [
        {
          path: ":nameTable/:idTable",
          element: (
            <Authenticated>
              <EditMasterTables />
            </Authenticated>
          ),
        },
      ],
    },
  ],
};

export default routesMasterTables;
